import React, { useEffect, useState, Fragment, MouseEvent } from "react";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react";
import { Button, IconButton } from "@mui/material";
import { styled } from "@mui/system";
import { isEmpty } from "lodash";

import "./scss/index.scss";
import Color from "@tool/color";
import {
  PromptIcon,
  VPlay,
  RencaiIcon2,
  XinchouIcon,
  YangbenIcon2,
  XinzhiLarge,
  UpIcon,
  DownIcon,
} from "@styled/icon";
import VideoCover from "@image/pic10.png";
import moTop, { onPlay } from "./top";
import { newRate, locateValue } from "@tool/index";
import MultiVideo from "@/component/video-play/multi-video";

interface IProps {}
interface IState {}

const DIconButton = styled(IconButton)(() => ({
  width: "24px",
  height: "24px",
  padding: 0,
  borderRadius: "5px",
  backgroundColor: "rgba(51, 53, 61, 1)",

  "&:hover": { backgroundColor: "rgba(51, 53, 61, 1)" },
}));

const EIconButton = styled(IconButton)(() => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  marginTop: "-20px",
  marginLeft: "-20px",
  padding: 0,
  zIndex: 510,
}));

const Top = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { amountChange, companyCount, salaryChange, updateTime } = moTop;
  const [isPop1, setPop1] = useState(false);
  const [isPop2, setPop2] = useState(false);
  const [isPop3, setPop3] = useState(false);
  const [isOpen, setIsopen] = useState(true);

  const videoList = [
    {
      title: '人力核心指标功能简介',
      src: 'https://file.smartsalary.cn/web-img%402.0/market/video/index.mp4',
      page: 'https://file.smartsalary.cn/web-img%402.0/market/video/index.png',
      name: '',
    },
    {
      title: '人力指标',
      src: 'https://file.smartsalary.cn/web-img%402.0/market/video/index1.mp4',
      name: '第一部分：',
      page: 'https://file.smartsalary.cn/web-img%402.0/market/video/index1.png',
    },
    {
      title: '人才需求',
      src: 'https://file.smartsalary.cn/web-img%402.0/market/video/index2.mp4',
      name: '第二部分：',
      page: 'https://file.smartsalary.cn/web-img%402.0/market/video/index2.png',
    },
    {
      title: '福利洞察',
      src: 'https://file.smartsalary.cn/web-img%402.0/market/video/index3.mp4',
      name: '第三部分：',
      page: 'https://file.smartsalary.cn/web-img%402.0/market/video/index3.png',
    },
  ];

  // 播放视频
  const onPlay = () => {
    // setUrl(
    //   'https://file.smartsalary.cn/v2-video/effect-video.mov',
    // );
    setIsopen(true);
  };

  useEffect(() => {
    return () => {};
  }, []);

  const hoverPop1 = (ev: MouseEvent) => {
    ev.stopPropagation();
    setPop1(true);
  };

  const leavePop1 = (ev: MouseEvent) => {
    ev.stopPropagation();
    setPop1(false);
  };

  const hoverPop2 = (ev: MouseEvent) => {
    ev.stopPropagation();
    setPop2(true);
  };

  const leavePop2 = (ev: MouseEvent) => {
    ev.stopPropagation();
    setPop2(false);
  };

  const hoverPop3 = (ev: MouseEvent) => {
    ev.stopPropagation();
    setPop3(true);
  };

  const leavePop3 = (ev: MouseEvent) => {
    ev.stopPropagation();
    setPop3(false);
  };

  return (
    <section className="index-top_10">
      <section className="section-10">
        <section className="section-11">
          <strong>人力核心指标</strong>
          {/* yingyang 客户要求不显示Logo之类的内容, 经bob讨论直接不显示这块内容 */}
          {/* <p className="line-10 line-11">
            <span>数据来源：</span>
            <XinzhiLarge />
            <img
              src="https://file.smartsalary.cn/web-img%402.0/market/image/gulu-logo.png"
              height="20"
              alt=""
            />
          </p> */}
          <p className="line-10 line-12">
            <span>数据更新时间：{updateTime}</span>
          </p>
        </section>
        <p className="section-12">
          洞察行业内人力资源相关核心数据。为年度薪酬成本规划、人才招募及保留、薪酬福利等各个人力资源管理环节的政策制定，提供数据指引。数据保持动态更新，用正在发生的数据制定明天的政策。
        </p>
        <i className="hline-11" />
        <section className="section-13">
          <section
            className="line-13"
            onMouseEnter={(ev: MouseEvent) => hoverPop1(ev)}
            onMouseLeave={(ev: MouseEvent) => leavePop1(ev)}
          >
            <p>
              <DIconButton>
                <RencaiIcon2 />
              </DIconButton>
              <span className="text-1010">人才需求变化</span>
            </p>
            <p>
              {/* <strong>32955</strong> */}
              <b
                className={[
                  Number(amountChange) > 0 ? "up-1011" : "down-1011",
                ].join(" ")}
              >
                {newRate(amountChange)}
              </b>
              <span className="arrow-1010">
                {Number(amountChange) > 0 ? <UpIcon /> : null}
                {Number(amountChange) < 0 ? <DownIcon /> : null}
              </span>
            </p>
            {isPop1 ? (
              <section className="line-popper">
                <p>所选行业下，近一年招聘岗位数量的同比变化。</p>
                <i />
              </section>
            ) : null}
            {isPop1 ? (
              <p className="shadow_0961">
                <img
                  src="https://file.smartsalary.cn/web-img%402.0/market/image/shadow-bg-grey.png"
                  alt=""
                />
              </p>
            ) : null}
          </section>
          <section
            className="line-13"
            onMouseEnter={(ev: MouseEvent) => hoverPop2(ev)}
            onMouseLeave={(ev: MouseEvent) => leavePop2(ev)}
          >
            <p>
              <DIconButton>
                <XinchouIcon />
              </DIconButton>
              <span className="text-1010">涨薪率</span>
            </p>
            <p>
              {/* <strong>32955</strong> */}
              <b
                className={[
                  Number(salaryChange) > 0 ? "up-1011" : "down-1011",
                ].join(" ")}
              >
                {newRate(salaryChange)}
              </b>
              <span className="arrow-1010">
                {Number(salaryChange) > 0 ? <UpIcon /> : null}
                {Number(salaryChange) < 0 ? <DownIcon /> : null}
              </span>
            </p>
            {isPop2 ? (
              <section className="line-popper">
                <p>所选行业下，近一年全部样本的薪酬同比变化。</p>
                <i />
              </section>
            ) : null}
            {isPop2 ? (
              <p className="shadow_0961">
                <img
                  src="https://file.smartsalary.cn/web-img%402.0/market/image/shadow-bg-grey.png"
                  alt=""
                />
              </p>
            ) : null}
          </section>
          <section
            className="line-13"
            onMouseEnter={(ev: MouseEvent) => hoverPop3(ev)}
            onMouseLeave={(ev: MouseEvent) => leavePop3(ev)}
          >
            <p>
              <DIconButton>
                <YangbenIcon2 />
              </DIconButton>
              <span className="text-1010">公司数</span>
            </p>
            <p>
              {/* <strong>32955</strong> */}
              <b style={{ marginRight: "10px" }}>{locateValue(companyCount)}</b>
              {/* <span className="arrow-1010">
                <UpIcon />
                <DownIcon />
              </span> */}
            </p>
            {isPop3 ? (
              <section className="line-popper">
                <p>所选行业下，全部样本所在公司的数量。</p>
                <i />
              </section>
            ) : null}
            {isPop3 ? (
              <p className="shadow_0961">
                <img
                  src="https://file.smartsalary.cn/web-img%402.0/market/image/shadow-bg-grey.png"
                  alt=""
                />
              </p>
            ) : null}
          </section>
        </section>
      </section>
      {/* <section className="section-160">
        <EIconButton onClick={onPlay}>
          <VPlay width={40} height={40} />
        </EIconButton>
        <img src={VideoCover} alt="" />
      </section> */}
      <section className="img-10306" aria-hidden="true" onClick={onPlay}>
        <img
          src="https://file.smartsalary.cn/web-img%402.0/market/video/index.png"
          alt="cover"
          className="img-1122"
        />
        <VPlay />
      </section>
      <MultiVideo
            isOpen={isOpen}
            videoList={videoList}
            close={() => {
              setIsopen(false);
            }}
            url="https://file.smartsalary.cn/web-img%402.0/market/video/index.mp4"/>
    </section>
  );
};

export default observer(Top);
